import {
  type AiBuilderDifficultyHint,
  type AiBuilderQuizTypeHint,
} from '../utils/types';

export const AI_GENERATE_DOCK_COUNT_PRESETS = [5, 10, 15, 20] as const;

export const AI_GENERATE_DOCK_DEFAULT_COUNT = 10;

export const AI_GENERATE_DOCK_TOPIC_MAX_LENGTH = 1000;

export const AI_GENERATE_DOCK_SOURCE_TYPES = [
  'query',
  'file',
  'youtube',
  'website',
] as const;

export type AiGenerateDockSourceType =
  (typeof AI_GENERATE_DOCK_SOURCE_TYPES)[number];

export type AiGenerateDockLinkSourceType = Extract<
  AiGenerateDockSourceType,
  'youtube' | 'website'
>;

export type AiGenerateDockCountPreset =
  (typeof AI_GENERATE_DOCK_COUNT_PRESETS)[number];

/** 조건 목록에 보이는 순서 — 빌드 화면의 문제 유형 버튼 순서와 같다. */
export const AI_GENERATE_DOCK_QUIZ_TYPES = [
  'multiple',
  'subjective',
  'ox',
  'essay',
] as const satisfies readonly AiBuilderQuizTypeHint[];

export const AI_GENERATE_DOCK_DEFAULT_QUIZ_TYPES: AiBuilderQuizTypeHint[] = [
  'multiple',
  'ox',
];

/** 조건 메뉴 순서 — 섞기('mixed')가 먼저, 그다음 쉬움·보통·어려움(서버 1·2·3). */
export const AI_GENERATE_DOCK_DIFFICULTIES = [
  'mixed',
  1,
  2,
  3,
] as const satisfies readonly AiBuilderDifficultyHint[];

export type AiGenerateDockDifficulty =
  (typeof AI_GENERATE_DOCK_DIFFICULTIES)[number];

/** 기본값은 섞기 — 조건 요약에는 기본값이 아닐 때만 난이도를 붙인다. */
export const AI_GENERATE_DOCK_DEFAULT_DIFFICULTY: AiGenerateDockDifficulty =
  'mixed';
